import React,{Component} from 'react';
import Notification from './Notification';
import API from './API';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import PoistonVarmistus from './PoistonVarmistus';
let APP_BASE_URL;
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
 
  APP_BASE_URL = "https://forestlogbook.herokuapp.com/workerRegister?token=";
 }else{
    
  APP_BASE_URL = "https://forestlogbook.herokuapp.com/workerRegister?token=";
 }
const SafeGuardApi = new API();
class AddWorkerView extends Component{

  constructor(props){
    super(props);
    this.state = {linkCreated:false,workerSignInLink:  this.props.worker != undefined && this.props.worker.accessToken != undefined ? APP_BASE_URL+ this.props.worker.accessToken:null,worker: this.props.worker == undefined ? {workerName:"",phonenumber:"",email:""}: this.props.worker,copied:false};
    this.updateInputValue = this.updateInputValue.bind(this);
    this.saveWorker = this.saveWorker.bind(this);
    this.deleteWorker = this.deleteWorker.bind(this);
    this.createLink = this.createLink.bind(this);
    this.setSignInLink = this.setSignInLink.bind(this);
    this.copyCodeToClipboard = this.copyCodeToClipboard.bind(this);
    this.handlePeruutaPoisto = this.handlePeruutaPoisto.bind(this);
    this.handleDeleteWorker = this.handleDeleteWorker.bind(this);
    this.updateWorker = this.updateWorker.bind(this);
    this.sendSmsToUser = this.sendSmsToUser.bind(this);
  }
  updateInputValue(evt) {
    let inputName =  evt.target.name;

    let worker = this.state.worker;
    worker[inputName]= evt.target.value;
    this.setState({worker:worker});

   }
   handlePeruutaPoisto(){
    
    this.setState({confirmDelete:false});
   }
   componentDidMount(){
    this.setState({workerSignInLink:this.props.worker != undefined && this.props.worker.accessToken != undefined ? APP_BASE_URL+ this.props.worker.accessToken:null});
    console.log("componentDidMount");
    
    if(this.props.createAccessToken == true){
      console.log(this.props.worker.accessToken);
      this.props.setcreateAccessTokenToFalse();
    }

   }



   
   saveWorker(){
     this.props.saveWorker(this.state.worker);
   }
   updateWorker(){
     let worker = this.state.worker;
    let _this = this;
     
     SafeGuardApi.createNewTokenForWorker(_this.state.worker,(newAccessToken) => {
      let signURL = APP_BASE_URL + newAccessToken;
      this.setState({workerAccessToken:newAccessToken});
      _this.setSignInLink(signURL);
      let newWorker = worker;
      newWorker.accessToken = newAccessToken
      this.setState({worker:newWorker});
 
     },() => {
 
     });
   }
   deleteWorker(){
    this.setState({confirmDelete:true});
  }

  handleDeleteWorker(){

    this.props.deleteWorker(this.state.worker);
  }
  setSignInLink(signURL){
    this.setState({workerSignInLink: signURL});
   
  }
  createLink(){
    let _this = this;
    SafeGuardApi.createNewTokenForWorker(_this.state.worker,(newAccessToken) => {
     let signURL = APP_BASE_URL + newAccessToken;
     this.setState({workerAccessToken:newAccessToken});
    this.setState({linkCreated:true});
     _this.setSignInLink(signURL);


    },() => {

    });
   
  }
  sendSmsToUser(){
 
  }
  copyCodeToClipboard = () => {
    const el = this.textArea
    el.select()
    document.execCommand("copy")
    el.blur();
  }

   

  render(){
    window.scrollTo(0, 0); 
       
    
    /*if(this.props.createAccessToken == true){
      
      console.log("Create AccessToken send");
  
      console.log(this.props.worker.accessToken);
      this.props.setcreateAccessTokenToFalse();
  

    }*/
    
    let createLinkButton = <></>;
    let  message;
    if(this.state.workerSignInLink != undefined){
      message = "Lataa https://play.google.com/store/apps/details?id=fi.t.forestsafetyapp ja klikkaa linkkiä:  " + this.state.workerSignInLink;
    }else{
      message = "";
    }
    let messageWithOnlyToken;
    if(this.state.workerAccessToken != undefined){
      messageWithOnlyToken = "Lataa https://play.google.com/store/apps/details?id=fi.t.forestsafetyapp ja syötä sovellukselle koodi:  " + this.state.workerAccessToken;
    }else{
      messageWithOnlyToken = "";
    }
    const isAdmin = this.props.isAdmin;
    let userVersion =  this.props.isAdmin ?  this.state.worker.version : "";
    userVersion = this.props.isAdmin ? "Version:" + userVersion: "";

    let permissions =  this.props.isAdmin ?  this.state.worker.permissions : "";
    permissions = this.props.isAdmin ? "Permissions:" + permissions : "";
    let workerPhonenumber = this.state.worker != undefined && this.state.worker.phonenumber != undefined ? this.state.worker.phonenumber : "";
    let smsLink = "sms://" + workerPhonenumber + "/?body=" + encodeURIComponent(message);
    let smsLinkWithToken = "sms://" + workerPhonenumber + "/?body=" + encodeURIComponent(messageWithOnlyToken);
    if(this.state.worker != undefined && this.state.worker.accessToken != undefined){
      createLinkButton = <div className="createLinkButtonContainer"><button className="btn" type="button" onClick={this.createLink}><span className="glyphicon glyphicon-link">&nbsp;</span>&nbsp;Uusi linkki&nbsp;</button></div>;
    }
   /* =  <div className="createLinkButtonContainer"><button className="glyphicon glyphicon-link btn" type="button" onClick={this.createLink}>&nbsp;</button></div>;*/
  //  let linkOperations =  this.state.worker._id ? <div  className="createLinkButtonContainer"><button  type="button"  onClick={() => this.copyCodeToClipboard()} className="glyphicon glyphicon-send">&nbsp;</button><textarea id="link" className="createdLink"  ref={(textarea) => this.textArea = textarea} readOnly value={this.state.workerSignInLink}></textarea></div> : <></>;
    let linkOperations =  this.state.worker._id ?<> <div  className="createLinkButtonContainer"><a href={smsLink} target="_blank"><button  type="button"  onClick={() => this.sendSmsToUser} className="btn"><span className="glyphicon glyphicon-send">&nbsp;</span>&nbsp;Lähetä linkki</button></a></div> 
    <div  className="createLinkButtonContainer"><a href={smsLinkWithToken} target="_blank"><button  type="button"  onClick={() => this.sendSmsToUser} className="btn"><span className="glyphicon glyphicon-send">&nbsp;</span>&nbsp;Lähetä koodi</button></a></div></>: <></>;
    //let linkOperations =  this.state.worker._id ? <CopyToClipboard text={this.state.workerSignInLink} onCopy={() => this.setState({copied: true})}> <button className="glyphicon glyphicon-share btn">&nbsp;</button></CopyToClipboard>: <></>;
  let linkCreationNotice = this.state.linkCreated == true ? <span className="linkCreationNotice">Uusi kirjautumislinkki luotu</span> : <></>;
    if(this.state.workerSignInLink == null){
      linkOperations = <></>;
    }else{
     
    
    } 
   
 
    return(

      <div className="addWorkerView">
        <PoistonVarmistus  naytaPoistonVarmistus={this.state.confirmDelete} handlePoisto={this.handleDeleteWorker} handlePeruutaPoisto={this.handlePeruutaPoisto}/>
<div className="workersListHeader alert alert-info">Työntekijän tiedot</div>
        <form>
          <label htmlFor="workerName" ><span>Nimi</span><input type="text"  name="workerName"  value={this.state.worker.workerName} onChange={evt => this.updateInputValue(evt)} /></label>
          <label htmlFor="phonenumber" ><span>Puh</span><input type="tel"   value={this.state.worker.phonenumber} name="phonenumber" onChange={evt => this.updateInputValue(evt)} /></label>
          <label htmlFor="email" ><span>Sähköposti</span><input type="email"   value={this.state.worker.email} name="email" onChange={evt => this.updateInputValue(evt)} /></label>
          {createLinkButton}
          
          {linkOperations}
          {linkCreationNotice}
          <p>{userVersion}</p>
          <p>{permissions}</p>
          <button type="button" className="btnSecondButton" onClick={this.deleteWorker}>Poista</button>
          <button type="button" className="btnThirdButton" onClick={this.saveWorker}>Tallenna</button>
          <button type="button" className="btnClose" onClick={this.props.changeToEmployeesView}>Peruuta</button>
        </form>
    </div>
)
}
}
export default AddWorkerView;
